<button class='btn-image'><img [src]="src"></button>
